import en from "./en";
import ml from "./ml";

const translations = { EN: en, ML: ml };

export default translations;
